export enum NotificationStatuses {
  NEW_TOP_ELEMENT_TESTED = "NEW_TOP_ELEMENT_TESTED",
  NEW_TOP_CONVERSION = "NEW_TOP_CONVERSION",
  COMPLETED_TEST = "COMPLETED_TEST",
  NEW_BCR_CALCULATION = "NEW_BCR_CALCULATION",
  ELIMINATED_CONTROL_ASSET = "ELIMINATED_CONTROL_ASSET",
}
